import React from "react";

import { useState, useEffect } from "react";

import logo from "../../../assets/img/logo.svg";

export default function MissionsToComeWidget({ missions }) {
    return (
            <div className="missions-to-come-widget">
                <p>Missions</p>
                <div>

                    <h3>A venir </h3>
                    <span className={"dot"}> {missions.length} </span>
                </div>
                <p>Mardi 25 mars 2025</p>
                <p>3 intérimaires</p>
                <div>
                {missions.map((mission, i) => (
                    <div key={i} className="mission-card">
                        <img src={logo} />
                        <p>Name</p>
                        <div>
                            <p>job</p>
                            <p>time period</p>
                        </div>
                    </div>
                ))}
                </div>
            </div>
    )
}